import { downloadFile } from 'src/download_file';
import { Attachment } from '@beunity/design';

Attachment.downloadFile = downloadFile;

export default Attachment;

// Hack for Rails preview:
// customElements.get('bu-attachment') || customElements.define('bu-attachment', Attachment);
